import React, { useEffect, useState } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import {
  getOrganization,
  deleteOrganization,
} from "../../store/slices/organization";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function Organization() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { organizationlist = [], loading } = useSelector(
    (state) => state.organization,
  );

  const pagelimit = 25;
  const [currentPage, setCurrentPage] = useState(1);

  const fetchOrganizations = async () => {
    try {
      await dispatch(getOrganization()).unwrap();
    } catch (error) {
      toast.error(error?.message || "Failed to load organizations");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this organization?"))
      return;

    try {
      await dispatch(deleteOrganization(id)).unwrap();
      toast.success("Organization deleted successfully");
      fetchOrganizations();
    } catch (error) {
      toast.error(error?.message || "Failed to delete organization");
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  // Pagination
  const totalPages = Math.ceil(organizationlist.length / pagelimit);
  const startIndex = (currentPage - 1) * pagelimit;
  const paginatedData = organizationlist.slice(
    startIndex,
    startIndex + pagelimit,
  );

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/superadmin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/superadmin/organization")}
          >
            Organization
          </span>
        </div>

        {/* Right: Button */}
        <button
          className="add-outlet-btn"
          onClick={() => navigate("/superadmin/addorganization")}
        >
          Add Organization
        </button>
      </div>
      <Container fluid>
        <Card style={{ border: "none" }}>
          <Card.Body>
            <div className="common-table-wrapper">
              <table className="common-table">
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>#</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th style={{ width: "120px", textAlign: "center" }}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4 text-muted">
                        {loading ? "Loading..." : "No Data Found"}
                      </td>
                    </tr>
                  ) : (
                    paginatedData.map((item, index) => (
                      <tr key={item._id}>
                        <td>{startIndex + index + 1}</td>
                        <td className="text-muted">{item.name}</td>
                        <td>{item.type}</td>
                        <td>{item.email}</td>
                        <td>{item.mobileNumber}</td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center align-items-center gap-3 flex-row">
                            <FaEdit
                              size={18}
                              style={{ cursor: "pointer" }}
                              className="text-primary"
                              onClick={() =>
                                navigate(
                                  `/superadmin/editorganization/${item._id}`,
                                )
                              }
                            />

                            <FaTrash
                              size={18}
                              style={{ cursor: "pointer" }}
                              className="text-danger"
                              onClick={() => handleDelete(item._id)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
